export default { sha: '0f43abfc0d58b4f1dc0ddd40941415226b2eb159', buildNumber: 'undefined' }
